import { render, staticRenderFns } from "./AgentProfit.vue?vue&type=template&id=28a91af0&scoped=true"
import script from "./AgentProfit.vue?vue&type=script&lang=js"
export * from "./AgentProfit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a91af0",
  null
  
)

export default component.exports